import React from 'react';
import ReactDOM from 'react-dom';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Transition from 'react-transition-group/Transition';
import { Document, Page } from 'react-pdf/dist/entry.noworker';
import './styles/preview-report.scss';

class Preview extends React.Component {
    constructor(props) {
        super(props);

        this.slug = window.location.pathname.replace(/\/reports\//gi, '').slice(0, -1);

        this.state = {
            previewPDF: false,
            isOpen: false,
            pageNumber: 1
        }

    }

    componentWillMount() {
        const endpoint = `/wp-json/wp/v2/reports?slug=${this.slug}`;
        const myRequest = new Request(endpoint);
        fetch(myRequest).then((response) => response.json()).then((response) => {
            if (typeof response[0].acf.preview_report !== undefined) {
                this.setState(() => {
                    return {
                        previewPDF: response[0].acf.report_preview
                    }
                }, () => console.log(this.state));
            }
        });
    }

    openPreview = (e) => {
        e.preventDefault();
        this.setState(() => {
            return {
                isOpen: true
            };
        });
    }

    closePreview = (e) => {
        e.preventDefault();
        this.setState(() => {
            return {
                isOpen: false
            };
        });
    }

    onDocumentLoadSuccess = ({numPages}) => {
        this.setState(() => {
            return {
                numPages
            };
        });
    };

    nextPage = () => {
        this.setState((prevState) => {
            if (prevState.numPages == prevState.pageNumber)
                return;

            return {
                pageNumber: prevState.pageNumber + 1
            }
        });
    }

    prevPage = () => {
        this.setState((prevState) => {
            if (prevState.pageNumber == 1)
                return;

            return {
                pageNumber: prevState.pageNumber - 1
            }
        });
    }

    render() {
        const { pageNumber } = this.state;

        const defaultStyles = {
            opacity: 0,
            transition: "opacity 0.5s ease"
        };
        const transitionStyles = {
            entering: {},
            entered: {
                opacity: 1
            }
        };

        return (
            <div>
                {this.state.previewPDF &&
                <div>
                    <a onClick={this.openPreview} class="button-one green report-button preview semi-bold">Preview Report</a>
                    {this.state.isOpen &&
                        <Transition
                            in={true}
                            appear={true}
                            timeout={100}
                        >
                        {(state) =>
                            <div style={{...defaultStyles, ...transitionStyles[state]}} className="preview-pdf">
                                <Document
                                    file={this.state.previewPDF}
                                    onLoadSuccess={this.onDocumentLoadSuccess}
                                    className="pdf-document"
                                >
                                    <Page
                                        width={600}
                                        pageNumber={pageNumber}
                                    />
                                </Document>
                                <span onClick={this.prevPage} className="prev-page"><i className="fa fa-chevron-left"></i></span>
                                <span onClick={this.nextPage} className="next-page"><i className="fa fa-chevron-right"></i></span>
                                <span className="ecks" onClick={this.closePreview}><i className="fa fa-times"></i></span>
                            </div>
                        }
                        </Transition>
                    }
                </div>
                }
            </div>
        );
    }
}

ReactDOM.render(<Preview />, document.getElementById('preview'));

